import {observable, action} from "mobx";
import last = require("lodash/last");
import {screenLg} from "core/common/config/variables";

export interface TransitionItem {
  params: {};
  query: {};
  newQuery: {direction?: string};
  routeName: string;
  newRouteName: string;
  rootPage: any;
}


class UiService {

  @observable public transitionArray: TransitionItem[] = [];

  @observable private showToolbarAction: boolean = false;
  @observable private showDialogAction: boolean = false;

  public globalMediaQuery: MediaQueryList;

  constructor() {
    this.globalMediaQuery = window.matchMedia('only screen and (min-width: ' + screenLg + 'px)');
  }

  addMediaQueryListener(listener) {
    this.globalMediaQuery.addListener(listener);
  }

  removeMediaQueryListener(listener) {
    this.globalMediaQuery.removeListener(listener);
  }


  showToolbarActionFlag(): void {
    this.showToolbarAction = true;
  }

  hideToolbarActionFlag(): void {
    this.showToolbarAction = false;
  }

  getToolbarActionFlag(): boolean {
    return this.showToolbarAction;
  }

  showDialogActionFlag(): void {
    this.showDialogAction = true;
  }

  hideDialogActionFlag(): void {
    this.showDialogAction = false;
  }

  getDialogActionFlag(): boolean {
    return this.showDialogAction;
  }


  @action updateTransition(transitionItem: TransitionItem) {
    if (transitionItem.rootPage) {
      this.transitionArray = observable.shallowArray<TransitionItem>([transitionItem]);
    } else {
      if (transitionItem.newQuery.direction === 'up') {
        this.transitionArray.pop();
      } else {
        let lastTransitionItem = last(this.transitionArray);
        if (!lastTransitionItem || lastTransitionItem.newRouteName !== transitionItem.newRouteName) {
          this.transitionArray.push(transitionItem);
        }
      }
    }
  }
}

const uiService = new UiService();
export default uiService;





// WEBPACK FOOTER //
// ./src/core/common/service/uiService.ts